'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initFormHandler = initFormHandler;
exports.initFormAfterErrorHandler = initFormAfterErrorHandler;

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _sagaUtils = require('@wh/saga-utils');

var _messageBus = require('@wh/message-bus');

var _tracking = require('./tracking');

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

var _constants = require('./../constants');

var _actions = require('./actions');

var _actions2 = require('../login-form/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(initFormHandler),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(initFormAfterErrorHandler),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(trackingHandler),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchSagas);

var getCasClient = function getCasClient(client) {
    return client || global.WH.casClient;
};
/**
 * Process init form
 * @param {Object} action Action of type INIT_FORM
 * @returns {Iterator} Iterator
 */
function initFormHandler(action) {
    var casClient, dataFromCas;
    return _regenerator2.default.wrap(function initFormHandler$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    // TODO: (LC-116) Think about better solution...
                    casClient = getCasClient(action.casClient);
                    _context.prev = 1;
                    _context.next = 4;
                    return (0, _effects.put)((0, _actions.fetchStarted)());

                case 4:
                    _context.next = 6;
                    return (0, _effects.apply)(casClient, casClient.getFormDefaults);

                case 6:
                    dataFromCas = _context.sent;
                    _context.next = 9;
                    return (0, _effects.put)((0, _actions.loginFormInitialized)(dataFromCas));

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)((0, _actions.fetchFinished)());

                case 11:
                    _context.next = 26;
                    break;

                case 13:
                    _context.prev = 13;
                    _context.t0 = _context['catch'](1);
                    _context.next = 17;
                    return (0, _effects.put)((0, _actions.fetchFinished)());

                case 17:
                    if (!(_context.t0 && _context.t0.next)) {
                        _context.next = 24;
                        break;
                    }

                    _context.next = 20;
                    return (0, _effects.put)((0, _actions2.userLoggedIn)(_context.t0));

                case 20:
                    _context.next = 22;
                    return (0, _effects.put)((0, _actions.trackingEvent)(_constants.TRACKING_EVENT_NAME_ALREADY_LOGGED_IN));

                case 22:
                    _context.next = 26;
                    break;

                case 24:
                    _context.next = 26;
                    return (0, _effects.put)((0, _actions.loginFormInitialiationFailed)());

                case 26:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[1, 13]]);
}

/**
 * Process init form after error which is shown above login form
 * Login form needs to be refreshed to get new ticket id from CAS
 * @param {Object} action Action of type USER_LOGIN_FAILED
 * @returns {Iterator} Iterator
 */
function initFormAfterErrorHandler(action) {
    var message;
    return _regenerator2.default.wrap(function initFormAfterErrorHandler$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    message = (0, _utils2.default)(action);

                    if (!(message.whereToDisplay === _constants.CALL_DISPLAY_LOGIN_FORM)) {
                        _context2.next = 4;
                        break;
                    }

                    _context2.next = 4;
                    return (0, _effects.put)((0, _actions.initForm)(global.WH.casClient));

                case 4:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Processes tracking events
 * @param {Object} action Tracked action
 * @returns {iterator} Iterator
 */
function trackingHandler(action) {
    var _convertActionToTrack, eventName, trackingData;

    return _regenerator2.default.wrap(function trackingHandler$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _convertActionToTrack = (0, _tracking.convertActionToTrackingData)(action), eventName = _convertActionToTrack.eventName, trackingData = (0, _objectWithoutProperties3.default)(_convertActionToTrack, ['eventName']);
                    _context3.next = 3;
                    return (0, _effects.call)(_messageBus.publish, eventName, trackingData);

                case 3:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

/**
 * Watch sagas
 * @returns {void}
 */
function watchSagas() {
    return _regenerator2.default.wrap(function watchSagas$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.spawn)(_reduxSaga.takeLatest, _constants.INIT_FORM, initFormHandler);

                case 2:
                    _context4.next = 4;
                    return (0, _effects.spawn)(_reduxSaga.takeLatest, _constants.USER_LOGIN_FAILED, initFormAfterErrorHandler);

                case 4:
                    _context4.next = 6;
                    return (0, _effects.spawn)(_reduxSaga.takeLatest, _tracking.actionsToTrack, trackingHandler);

                case 6:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

exports.default = (0, _sagaUtils.setupSagaTarget)(watchSagas, true, true);
//# sourceMappingURL=sagas.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-component/sagas.js
// module id = 488
// module chunks = 0